<script>
  import {getContext} from 'svelte';
  import {goto} from '@sapper/app';
  import {Button} from '@px/button';
  import {PATHS} from '@/const/paths';
  import {LINKS} from '@/const/link';
  import {fixLink$} from '@/store/lang';
  import {fiatABTest$} from '@/modules/fiat/streams';
  import {contractMarkets$, spotMarkets$} from '@/modules/markets/streams';
  import {IMAGES} from '../images';
  import lang from '../HomePage.lang';

  const LG = getContext('LG');

  $: products = getProducts($fiatABTest$, $spotMarkets$, $contractMarkets$);

  function getProducts(fiatABTest, spotMarkets, contractMarkets) {
    return [
      {
        title: LG(lang.Reliable),
        desc: LG(lang.ReliableDesc),
        img: IMAGES.PRO1,
        alt: 'crypto leverage trading',
        actions: [
          {
            title: LG(lang.StartTrade, {Number: contractMarkets?.length}),
            action: LG(lang.TradingNow),
            href: '/trade/BTCUSDT',
          },
          {
            title: LG(lang.LowFee),
            action: LG(lang.Check),
            href: $fixLink$(PATHS.VIP_PROGRAM.pathname),
          },
          {
            title: LG(lang.OneClick),
            action: LG(lang.GoCopy),
            href: $fixLink$(PATHS.COPY_TRADING_LIST.pathname),
          },
        ],
      },
      {
        title: LG(lang.MostReward),
        desc: LG(lang.Trade249, {Number: spotMarkets?.length}),
        img: IMAGES.PRO2,
        alt: 'spot trading crypto',
        actions: [
          {
            title: LG(lang.Explore270, {Number: spotMarkets?.length}),
            action: LG(lang.TradingNow),
            href: LINKS.PHEMEX_SPOT_TRADE,
          },
          {
            title: LG(lang.BuyP2P),
            action: LG(lang.BuyCrypto),
            href: $fixLink$(fiatABTest ? PATHS.FIAT_BUY_CRYPTO_PLACE_ORDER.pathname : PATHS.OTC_LEGEND_TRADING.pathname),
          },
          {
            title: LG(lang.FindNext),
            action: LG(lang.Launchpad),
            href: $fixLink$(PATHS.LAUNCHPAD.pathname),
          },
        ],
      },
      {
        title: LG(lang.Grow),
        desc: LG(lang.EarBTC),
        img: IMAGES.PRO3,
        alt: 'earn crypto',
        actions: [
          {
            title: LG(lang.Stake),
            action: LG(lang.Launchpool),
            href: $fixLink$(PATHS.LAUNCHPOOL.pathname),
          },
          {
            title: LG(lang.Generate),
            action: LG(lang.SaveNow),
            href: $fixLink$(PATHS.EARN.pathname),
          },
          {
            title: LG(lang.ProfitFrom),
            action: LG(lang.Predicted),
            href: $fixLink$(PATHS.PREDICT_TO_EARN.pathname),
          },
        ],
      },
    ];
  }

  function buttonClickHandler(action) {
    return function () {
      goto(action.href);
    };
  }
</script>

<style>
  .outer {
    padding: 120px 0;
    background: #fff;
  }
  .wrap {
    margin: 0 auto;
    width: 1200px;
  }
  .caption {
    margin-top: 0;
    margin-bottom: 48px;
    font-size: 48px;
  }
  .desc {
    color: #777b83;
  }
  .product + :global(.product) {
    margin-top: 200px;
  }
  .product img {
    height: 200px;
  }
  .product-title {
    margin-top: 0;
    margin-bottom: 24px;
    font-size: 32px;
  }
  .product:nth-child(odd) {
    flex-direction: row-reverse;
  }
  /* 使用flex:1的話文案的寬度會不固定 */
  .product .content {
    width: 720px;
  }
  .action,
  .action-link {
    align-items: baseline;
    width: 200px;
  }
  .action-link :global(.medium.text:hover:before) {
    background: transparent;
  }
  .action-link :global(button) {
    padding: 0;
  }
  @media screen and (max-width: 640px) {
    .outer {
      padding: 48px 16px;
    }
    .wrap {
      width: auto;
    }
    .caption {
      margin-bottom: 36px;
      text-align: left;
      font-size: 18px;
    }
    .product,
    .product .content {
      width: auto;
    }
    .product {
      display: block;
    }
    .product img {
      display: block;
      margin: 0 auto 36px;
      height: 120px;
    }
    .product + :global(.product) {
      margin-top: 60px;
    }
    .product-title {
      margin-bottom: 12px;
      font-size: 16px;
    }
    .action {
      margin: 0;
      border: 1px solid #dbdfe7;
      border-radius: 20px;
      padding: 20px 16px;
      width: auto;
    }
    .action + :global(.action) {
      margin-top: 20px;
      margin-left: 0;
      width: auto;
    }
  }
</style>

<section class="outer">
  <div class="wrap">
    <h2 class="caption tc">{LG(lang.OurProducts)}</h2>
    {#each products as product}
      <div class="product df aifs jcsb">
        <img src={product.img} alt="product-icon" />
        <div class="content">
          <h3 class="product-title b">{product.title}</h3>
          <div class="desc mb32 f16">{product.desc}</div>
          <div class="df aifs jcsb xs:db f18">
            {#each product.actions as action}
              <div class="action df jcsb fw2" on:click={buttonClickHandler(action)}>
                <sapn>{action.title}</sapn> <i class="arrow-h5 iconfont dn ml8 f14 BLUE cp b xs:db">&#xe60b;</i>
              </div>
            {/each}
          </div>
          <div class="mt16 df aife jcsb f18">
            {#each product.actions as action}
              <div class="action-link">
                <Button type="text" class="p0 xs:dn" on:click={buttonClickHandler(action)}>
                  <div class="df aife fw3">
                    <span>{action.action}</span><i class="iconfont db ml8 f14 BLUE cp b">&#xe60b;</i>
                  </div>
                </Button>
              </div>
            {/each}
          </div>
        </div>
      </div>
    {/each}
  </div>
</section>
